const EmbeddedVideo = () => {
  const embeddedVideos = document.getElementsByClassName('embedded-video');

  if (!embeddedVideos.length) {
    return;
  }

  let hasMarketingConsent = false;
  const cookies = document.cookie.split('; ').filter((item) => item);

  cookies.forEach((cookie) => {
    const [cookieName, cookieValue] = cookie.split('=');

    if (cookieName === 'ob_consent') {
      hasMarketingConsent = !!JSON.parse(cookieValue).choices.find(
        ({ name: choiceName, value: choiceValue }) =>
          choiceName === 'marketing' && choiceValue === true,
      );
    }
  });

  Array.from(embeddedVideos).forEach((video) => {
    const dataUrl = video.dataset.url;
    if(!dataUrl) return;
    const src = hasMarketingConsent
      ? dataUrl
      : dataUrl.replace('youtube.com', 'youtube-nocookie.com');
    video.setAttribute('src', src);
  });
};

export default EmbeddedVideo();
